import React from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';
import DesktopSettings from './settings/Settings';
import MobileSettings from '../mobile/components/settings/Settings';

const ResponsiveSettings = () => {
  const isMobile = useMediaQuery('(max-width: 599px)');

  return isMobile ? <MobileSettings /> : <DesktopSettings />;
};

export default ResponsiveSettings; 